export const dataLinksOne = {
    title: 'About us',
    link1: 'How it works',
    link2: 'Testimonials',
    link3: 'Careers',
    link4: 'Investors',
    link5: 'Terms of Service',
}

export const dataLinksTwo = {
    title: 'Videos',
    link1: 'Submit Video',
    link2: 'Ambassadors',
    link3: 'Agency',
    link4: 'Influencer',
}

export const dataLinksThree = {
    title: 'Contact us',
    link1: 'Contact',
    link2: 'Support',
    link3: 'Destinations',
    link4: 'Sponsorships',
}

export const dataLinksFour = {
    title: 'Social Media',
    link1: 'Instagram',
    link2: 'Facebook',
    link3: 'Youtube',
    link4: 'Twitter'
}